module.exports = __webpack_public_path__ + "static/img/z5_title_bg.0a506a39.png";